import { render, staticRenderFns } from "./lkuKoranCustomer.vue?vue&type=template&id=51e5d789"
import script from "./lkuKoranCustomer.vue?vue&type=script&lang=js"
export * from "./lkuKoranCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports